function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function normalizeCrsText(s) {
  return String(s || "").trim().toUpperCase();
}

export function createIoService({ projections }) {
  function detectSourceCRS(featureCollection) {
    if (!featureCollection || typeof featureCollection !== "object") return null;
    const crsName = featureCollection?.crs?.properties?.name || featureCollection?.crs?.name || null;
    if (!crsName) return null;
    return normalizeCrsText(crsName);
  }

  function normalizeImportFeatureCollection(featureCollection, { sourceCRS = null, targetCRS = "EPSG:4326" } = {}) {
    if (!featureCollection || featureCollection.type !== "FeatureCollection" || !Array.isArray(featureCollection.features)) {
      throw new Error("Expected GeoJSON FeatureCollection");
    }
    const detected = detectSourceCRS(featureCollection);
    const from = normalizeCrsText(sourceCRS || detected || "EPSG:4326");
    const to = normalizeCrsText(targetCRS || "EPSG:4326");
    const transformed = projections.transformFeatureCollection(featureCollection, from, to);
    return {
      featureCollection: transformed,
      sourceCRS: from,
      targetCRS: to,
      transformed: from !== to,
    };
  }

  function prepareExportFeatureCollection(featureCollection, { sourceCRS = "EPSG:4326", targetCRS = "EPSG:4326", includeLegacyCrs = false } = {}) {
    if (!featureCollection || featureCollection.type !== "FeatureCollection" || !Array.isArray(featureCollection.features)) {
      throw new Error("Expected GeoJSON FeatureCollection");
    }
    const from = normalizeCrsText(sourceCRS || "EPSG:4326");
    const to = normalizeCrsText(targetCRS || "EPSG:4326");
    let out = projections.transformFeatureCollection(featureCollection, from, to);

    if (includeLegacyCrs) {
      out = clone(out);
      out.crs = { type: "name", properties: { name: to } };
    }

    return {
      featureCollection: out,
      sourceCRS: from,
      targetCRS: to,
      transformed: from !== to,
    };
  }

  return {
    detectSourceCRS,
    normalizeImportFeatureCollection,
    prepareExportFeatureCollection,
  };
}
